const importAll = (r) => r.keys().map(r);

export const foodDriveImages = importAll(require.context("../../public/assets/images/food-drive", false, /\.(jpg|jpeg|png)$/));
export const taxSeminarImages = importAll(require.context("../../public/assets/images/tax-seminar", false, /\.(jpg|jpeg|png|JPG)$/));
export const ugadiImages = importAll(require.context("../../public/assets/images/ugadi", false, /\.(jpg|jpeg|png)$/));
export const karthigaImages = importAll(require.context("../../public/assets/images/karthiga", false, /\.(jpg|jpeg|png|JPG)$/));
export const healthCampImages = importAll(require.context("../../public/assets/images/health-camp", false, /\.(jpg|jpeg|png)$/));
